import { useRecoilState } from 'recoil'
import clsx from 'clsx'
import IconArrowDown from '@/components/icons/IconArrowDown'
import { marketMapState, markPriceMapState } from '@/recoil/Market'
import { recentTradesState } from '@/recoil/RecentTrades'
import numberFormat from '@/utils/numberFormat'

export default function LastPrice({
  showPriceStatusIcon = true,
  showMarkPrice = false
}) {
  const [marketMap] = useRecoilState(marketMapState)
  const [markPriceMap] = useRecoilState(markPriceMapState)
  const [recentTrades] = useRecoilState(recentTradesState)

  const symbol = recentTrades.symbol
  const marketInfo = marketMap[symbol] || {}
  const isFutures = marketInfo.isFutures
  const priceFormat = marketInfo.priceDecimal || 0
  const recentTradesReady = recentTrades.list.length > 0
  const lastPrice = recentTrades.list[0] ? recentTrades.list[0].price : null
  const prevPrice = recentTrades.list[1] ? recentTrades.list[1].price : null
  const isSame = lastPrice === prevPrice
  const isUp = !isSame && lastPrice > prevPrice
  const isDown = !isSame && lastPrice < prevPrice

  return (
    <div
      className={clsx('last-price-container', {
        'price-up': isUp,
        'price-down': isDown
      })}
    >
      <div
        className={clsx('last-price', {
          'color-positive': isUp,
          'color-negative': isDown
        })}
      >
        {recentTradesReady && numberFormat(lastPrice, priceFormat)}
      </div>
      <div className="icon-price-status">
        {showPriceStatusIcon && !isSame && (
          <IconArrowDown
            className={clsx('icon-arrow', {
              'color-positive': isUp,
              'color-negative': isDown,
              'is-up': isUp
            })}
            aria-label="icon price status"
          />
        )}
      </div>
      {showMarkPrice && isFutures && markPriceMap[symbol] && (
        <div className="tooltip-container mark-price">
          {numberFormat(markPriceMap[symbol], priceFormat)}
          <div className="tooltip">
            Mark price is used for PnL calculation and liquidation
          </div>
        </div>
      )}
    </div>
  )
}
